/* stylelint-disable */
:host {
  display: inline-block;
}

.pes-qds--icon {
  height: 100%;
  width: 100%;
}

.qds-icon__wrapper {
  display: flex;
  pointer-events: none;
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 24px;
}